import styled from "@emotion/styled";
import { fontRoboto, theme, transientOptions } from "@product/scmp-sdk";

import { BaseLink } from "shared/components/common/base-link";

import { Avatar } from "scmp-app/components/avatar";

export const Container = styled.div``;

export const PlusHeaderContainer = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    z-index: 2;

    display: flex;

    padding-block: 20px;
    padding-inline: 28px;

    background: linear-gradient(180deg, rgba(247, 246, 239, 0.8) 0%, rgba(247, 246, 239, 0) 100%);

    transform: translate3d(0, 0, 0);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  max-inline-size: 1344px;
  margin-inline: auto;
  padding-block: 8px;
  padding-inline: 16px;

  border-radius: 12px;

  background-color: #30343c;

  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  ${theme.breakpoints.up("desktop")} {
    padding-inline: 32px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  block-size: 60px;

  &:first-child,
  &:last-child {
    inline-size: 30%;
  }
  &:last-child {
    justify-content: flex-end;
  }

  ${theme.breakpoints.up("desktop")} {
    gap: 12px;
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    gap: 20px;
  }
`;

interface HeaderLinkProps {
  $active?: string;
}

export const HeaderLink = styled(BaseLink, {
  ...transientOptions,
})<HeaderLinkProps>`
  display: flex;
  align-items: center;

  opacity: ${props => (props.$active ? 1 : 0.7)};

  &:hover {
    & > div:first-child {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  & > div:first-child {
    background: ${props => (props.$active ? "rgba(255, 255, 255, 0.20)" : "none")};
  }
`;

export const IconBackground = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 40px;
  block-size: 40px;

  border-radius: 8px;
`;

export const IconLabel = styled.div`
  display: none;
  ${theme.breakpoints.up("desktop")} {
    display: block;

    max-inline-size: 34px;
    margin-inline-start: 4px;

    color: #ffffff;
    font-weight: 400;
    font-size: 10px;
    font-family: ${fontRoboto};
  }
`;

export const DividingLine = styled.div`
  inline-size: 0;
  block-size: 40px;

  opacity: 0.5;
  border-inline-start: 1px solid #ffffff;
`;

export const Placeholder = styled.div`
  inline-size: 100%;
  block-size: 76px;
  max-inline-size: 1344px;
  margin-inline: auto;

  border-radius: 12px;

  background: rgba(0, 0, 0, 0.05);
`;

export const AvatarContent = styled.div`
  display: flex;
  gap: 28px;
  align-items: center;

  block-size: 60px;

  &:first-child,
  &:last-child {
    inline-size: 30%;
  }
  &:last-child {
    justify-content: flex-end;
  }
`;

export const StyledAvatar = styled(Avatar)`
  & {
    position: relative;

    inline-size: 46px;
    block-size: 46px;
  }
  & .sa-avatar-widget__image {
    position: absolute;
    inset-block-start: 50%;
    inset-inline-start: 50%;

    inline-size: 42px;
    block-size: 42px;
    margin: 0;

    border-radius: 50%;

    filter: none;
    transform: translate(-50%, -50%);

    overflow: hidden;
  }
  & .sa-avatar-widget__wrapper {
    background: #4585ff;
  }
`;

export const GreetingMessage = styled.div`
  display: none;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 16.41px;

  ${theme.breakpoints.up("desktop")} {
    display: block;
  }
`;

export const CtaMessageWrapper = styled.div`
  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: flex;
    gap: 8px;
  }
`;

export const CtaMessage = styled.div`
  display: none;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: normal;

  ${theme.breakpoints.up("desktop")} {
    display: block;
  }
`;

export const LoginButtonWrapper = styled.div`
  cursor: pointer;
`;
